import { ChefHat, Utensils, Wheat, Flame } from "lucide-react";

const PILLARS = [
  {
    icon: ChefHat,
    title: "Chef-Led, Family-Hosted",
    body:
      "Three generations of recipes — Soul, Spanish & Mediterranean — translated daily from a single home kitchen onto your plate.",
  },
  {
    icon: Wheat,
    title: "Sourced Local, Cooked Slow",
    body:
      "Texas farms, Gulf seafood, olive oil pressed for us in Andalucía. Stocks simmer overnight; nothing is rushed.",
  },
  {
    icon: Flame,
    title: "House Specials, Hand-Written",
    body:
      "The carte changes with the season. Ask for the day's pass-list — the dish your server lights up about is the one to order.",
  },
  {
    icon: Utensils,
    title: "From a Bite to a Buyout",
    body:
      "Takeout for a Tuesday, a long-table brunch for twelve, or a private dining room for a hundred and twenty. We do all of it.",
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="bg-[#FDFBF7] border-y border-[#E4DECD] py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-5">
          <div>
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              — The House Standard
            </p>
            <h2
              data-testid="pillars-heading"
              className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#1A1713]"
            >
              Corporate posture, <br />
              <em className="text-[#7A2021]">home-kitchen heart.</em>
            </h2>
          </div>
          <p className="max-w-sm text-[#5C5449] leading-relaxed">
            Four standards we hold ourselves to — every shift, every plate,
            every guest who walks through the door.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E4DECD]">
          {PILLARS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid="pillar-card"
                className="bg-[#FDFBF7] p-8 md:p-10 hover:bg-[#F5F2EA] transition-colors duration-500 flex flex-col"
              >
                <div className="flex items-start justify-between mb-7">
                  <Icon size={28} strokeWidth={1.25} className="text-[#7A2021]" />
                  <span className="font-mono-accent text-[11px] text-[#5C5449]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1713] leading-snug mb-4">
                  {p.title}
                </h3>
                <p className="text-[#5C5449] leading-relaxed text-sm">{p.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
